/**
 * Meta Pixel helper. The base script is loaded in index.html.
 * This module wraps window.fbq with TypeScript-safe helpers and
 * a no-op fallback when the pixel hasn't loaded (dev, ad-blockers, etc).
 */

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

export const META_PIXEL_ID = "938245875918439";

type StandardEvent =
  | "PageView"
  | "Lead"
  | "CompleteRegistration"
  | "InitiateCheckout"
  | "Purchase"
  | "Subscribe"
  | "ViewContent"
  | "Contact";

export function trackEvent(name: StandardEvent, params?: Record<string, unknown>) {
  if (typeof window === "undefined") return;
  try {
    window.fbq?.("track", name, params);
  } catch {
    /* swallow — analytics must never break the app */
  }
}

export function trackPageView() {
  trackEvent("PageView");
}
